import SessionManager  from  '../Manager/Session.manager'
import MainNotification from '../Manager/Notification/main.manager';
import { i18n } from '@/main';


export default class MessageHandler {
  constructor(){
  }
  /************************ Create users notification ***********************/
  static MentionNotification(chatMessage) {
      let mentioned_users = chatMessage.mentioned_users
      if(typeof mentioned_users != "undefined"){
        let channel = SessionManager.getChannel(chatMessage.channel_id)
        let channel_name = ''
        if(typeof channel != 'undefined'){
          channel_name = channel.channel_name
        }
        let curruser =   SessionManager.getUser(chatMessage.user_id)
        for(let i =0; i < mentioned_users.length;i++){
            let targetUser = SessionManager.getUser(mentioned_users[i])
            if(typeof targetUser != 'undefined'){
              if(SessionManager.getLoggedInUser().user_id == targetUser.user_id){
                let message = `${curruser.username} ${i18n.vm.messages[i18n.vm.locale]['has mentioned you in channel #']} ${channel_name}`
                // Maybe this is not needed
                // MainNotification.push(message)
              }
            }
        }
      }
  }
}
